module.exports = __webpack_public_path__ + "static/media/hand_with_pencil.01216654.png";